import InitialPasswordForm from '@sophocles/views/auth/forms/InitialPasswordForm';
import LoginForm from '@sophocles/views/auth/forms/LoginForm';
import MultiFactorChallengeForm from '@sophocles/views/auth/forms/MultiFactorChallengeForm';
import ResetPasswordForm from '@sophocles/views/auth/forms/ResetPasswordForm';

export default LoginForm;

export { InitialPasswordForm, MultiFactorChallengeForm, ResetPasswordForm };
